import { render, staticRenderFns } from "./WasteMeasureResults.vue?vue&type=template&id=51d3574f&"
import script from "./WasteMeasureResults.vue?vue&type=script&lang=js&"
export * from "./WasteMeasureResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports